import {
    Box,
    Button,
    Grid,
    GridItem,
    Heading,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    ModalFooter,
    Input,
    useDisclosure,
    Select,
    useToast,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    VStack,
    HStack,
    Badge,
    Divider,
    Checkbox,
    FormControl,
    FormLabel
} from "@chakra-ui/react";

import { useEffect, useState } from "react";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();
    const [newUser, setNewUser] = useState({ username: '', password: '', role: 1, external: false });
    const [currentUserRole, setCurrentUserRole] = useState(1);
    const toast = useToast();
    useEffect(() => {
        fetchUsers();
        fetchCurrentUser();
    }, []);
    const fetchCurrentUser = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/users/me', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Erro ao buscar usuário atual');
            const data = await response.json();
            setCurrentUserRole(data.role);
        } catch (error) {
            console.error('Erro:', error);
        }
    };
    const fetchUsers = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/users', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Erro ao buscar usuários');
            const data = await response.json();
            setUsers(data);
        } catch (error) {
            console.error('Erro:', error);
            toast({
                title: "Erro ao carregar usuários",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };
    const handleNewUserInputChange = (e) => {
        const { name, value } = e.target;
        setNewUser(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSelectedUserInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedUser(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleAddUser = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/users/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(newUser),
            });
            if (!response.ok) throw new Error('Erro ao adicionar usuário');
            fetchUsers();
            onClose();
            setNewUser({ username: '', password: '', role: 1, external: false });

            toast({
                title: "Usuário adicionado com sucesso",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            console.error('Erro:', error);
            toast({
                title: "Erro ao adicionar usuário",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };
    const handleUpdateUser = async () => {
        try {
            const token = localStorage.getItem('token');

            // Preparar dados para envio - não incluir password se estiver vazio
            const updateData = {
                username: selectedUser.username,
                role: parseInt(selectedUser.role),
                external: selectedUser.external || false
            };

            // Só adiciona password se não estiver vazio
            if (selectedUser.password && selectedUser.password.trim() !== '') {
                updateData.password = selectedUser.password;
            }

            const response = await fetch(`/api/users/${selectedUser.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(updateData),
            });
            if (!response.ok) throw new Error('Erro ao atualizar usuário');
            fetchUsers();
            onEditClose();

            toast({
                title: "Usuário atualizado com sucesso",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            console.error('Erro:', error);
            toast({
                title: "Erro ao atualizar usuário",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };
    const handleDeleteUser = async (userId) => {
        if (!window.confirm('Tem certeza que deseja excluir este usuário?')) return;
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/users/${userId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Erro ao deletar usuário');
            fetchUsers();
            toast({
                title: "Usuário deletado com sucesso",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            console.error('Erro:', error);
            toast({
                title: "Erro ao deletar usuário",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const handleInitiatePasswordReset = async (userId, username) => {
        if (!window.confirm(`Tem certeza que deseja solicitar redefinição de senha para ${username}?`)) return;
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/users/${userId}/initiate-password-reset`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Erro ao iniciar reset de senha');
            toast({
                title: "Reset de senha iniciado",
                description: `${username} precisará redefinir a senha no próximo login`,
                status: "success",
                duration: 5000,
                isClosable: true,
            });
        } catch (error) {
            console.error('Erro:', error);
            toast({
                title: "Erro ao iniciar reset de senha",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const getRoleText = (role) => {
        switch (role) {
            case 1: return "1 - Visualização de Passagens";
            case 2: return "2 - Lotes e Passagens";
            case 3: return "3 - Validação";
            case 4: return "4 - Supervisão";
            case 5: return "5 - Administrador";
            default: return "Desconhecido";
        }
    };

    return (
        <Box p={6} flex="1" minH="100vh" bg="gray.100" justify="center">
            <Heading mb={4}>
                Usuários
                <Button onClick={onOpen} ml={4} colorScheme="teal">Adicionar Usuário</Button>
            </Heading>

            {/* Informativo sobre os níveis de acesso */}
            <Alert status="info" mb={6} borderRadius="md" flexDirection="column" alignItems="flex-start">
                <HStack mb={2}>
                    <AlertIcon />
                    <AlertTitle>Níveis de Acesso e Permissões</AlertTitle>
                </HStack>
                <VStack align="stretch" spacing={3} pl={8} w="100%">
                    <Box>
                        <HStack>
                            <Badge colorScheme="blue" fontSize="sm">Nível 1</Badge>
                            <Text fontWeight="bold">Visualização de Passagens</Text>
                            <Badge colorScheme="green" fontSize="xs">Acesso Externo</Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Pode apenas visualizar passagens. Acesso liberado pela rede interna e externa.
                        </Text>
                    </Box>
                    <Divider />
                    <Box>
                        <HStack>
                            <Badge colorScheme="purple" fontSize="sm">Nível 2</Badge>
                            <Text fontWeight="bold">Lotes e Passagens</Text>
                            <Badge colorScheme="orange" fontSize="xs">Apenas Rede Interna</Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Pode visualizar e trabalhar com lotes de infrações. Requer acesso pela rede interna (10.10.50.x), exceto se marcado como "Externo".
                        </Text>
                    </Box>
                    <Divider />
                    <Box>
                        <HStack>
                            <Badge colorScheme="cyan" fontSize="sm">Nível 3</Badge>
                            <Text fontWeight="bold">Validação</Text>
                            <Badge colorScheme="orange" fontSize="xs">Apenas Rede Interna</Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Pode validar e confirmar/rejeitar infrações. Requer acesso pela rede interna (10.10.50.x), exceto se marcado como "Externo".
                        </Text>
                    </Box>
                    <Divider />
                    <Box>
                        <HStack>
                            <Badge colorScheme="yellow" fontSize="sm">Nível 4</Badge>
                            <Text fontWeight="bold">Supervisão</Text>
                            <Badge colorScheme="orange" fontSize="xs">Apenas Rede Interna</Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Pode supervisionar equipe, iniciar reset de senhas e gerenciar usuários. Requer acesso pela rede interna (10.10.50.x), exceto se marcado como "Externo".
                        </Text>
                    </Box>
                    <Divider />
                    <Box>
                        <HStack>
                            <Badge colorScheme="red" fontSize="sm">Nível 5</Badge>
                            <Text fontWeight="bold">Administrador</Text>
                            <Badge colorScheme="green" fontSize="xs">Acesso Externo</Badge>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Acesso completo ao sistema, incluindo configurações, câmeras e algoritmos. Acesso liberado de qualquer rede.
                        </Text>
                    </Box>
                </VStack>
            </Alert>

            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                {users.map((user) => (
                    <GridItem key={user.id} w="100%" bg="white" boxShadow="md" p={4} borderRadius="md">
                        <Text fontSize="lg" fontWeight="bold">{user.username}
                            {user.external && (
                                <Badge colorScheme="green" mt={1}>✓ Acesso Externo</Badge>
                            )}
                        </Text>
                        <Text>Nível: {getRoleText(user.role)}</Text>
                        <Button
                            colorScheme="teal"
                            size="sm"
                            mt={2}
                            mr={2}
                            onClick={() => {
                                setSelectedUser({ ...user, password: '', external: user.external || false });
                                onEditOpen();
                            }}
                        >
                            Editar
                        </Button>
                        {currentUserRole >= 4 && (
                            <Button
                                colorScheme="orange"
                                size="sm"
                                mt={2}
                                mr={2}
                                onClick={() => handleInitiatePasswordReset(user.id, user.username)}
                            >
                                Redefinir Senha
                            </Button>
                        )}
                        <Button
                            colorScheme="red"
                            size="sm"
                            mt={2}
                            onClick={() => handleDeleteUser(user.id)}
                        >
                            Excluir
                        </Button>
                    </GridItem>
                ))}
            </Grid>
            {/* Modal para adicionar novo usuário */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Adicionar Novo Usuário</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input
                            placeholder="Nome de usuário"
                            name="username"
                            value={newUser.username}
                            onChange={handleNewUserInputChange}
                            mb={4}
                        />
                        <Input
                            placeholder="Senha"
                            name="password"
                            type="password"
                            value={newUser.password}
                            onChange={handleNewUserInputChange}
                            mb={4}
                        />
                        <Select
                            name="role"
                            value={newUser.role}
                            onChange={handleNewUserInputChange}
                            mb={4}
                        >
                            <option value={1}>Nível 1 - Visualização de Passagens</option>
                            <option value={2}>Nível 2 - Lotes e Passagens</option>
                            <option value={3}>Nível 3 - Validação</option>
                            <option value={4}>Nível 4 - Supervisão</option>
                            <option value={5}>Nível 5 - Administrador</option>
                        </Select>
                        <FormControl>
                            <Checkbox
                                isChecked={newUser.external}
                                onChange={(e) => setNewUser(prev => ({ ...prev, external: e.target.checked }))}
                            >
                                <FormLabel mb={0}>Permitir Acesso Externo</FormLabel>
                            </Checkbox>
                            <Text fontSize="xs" color="gray.500" mt={1}>
                                Permite que o usuário acesse o sistema fora da rede interna (independente do nível)
                            </Text>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" onClick={handleAddUser}>Adicionar</Button>
                        <Button onClick={onClose} ml={3}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* Modal para editar usuário */}
            <Modal isOpen={isEditOpen} onClose={onEditClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Editar Usuário</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input
                            placeholder="Nome de usuário"
                            name="username"
                            value={selectedUser?.username || ''}
                            onChange={handleSelectedUserInputChange}
                            mb={4}
                        />
                        <Input
                            placeholder="Nova senha (opcional)"
                            name="password"
                            type="password"
                            onChange={handleSelectedUserInputChange}
                            mb={4}
                        />
                        <Select
                            name="role"
                            value={selectedUser?.role || 1}
                            onChange={handleSelectedUserInputChange}
                            mb={4}
                        >
                            <option value={1}>Nível 1 - Visualização de Passagens</option>
                            <option value={2}>Nível 2 - Lotes e Passagens</option>
                            <option value={3}>Nível 3 - Validação</option>
                            <option value={4}>Nível 4 - Supervisão</option>
                            <option value={5}>Nível 5 - Administrador</option>
                        </Select>
                        <FormControl>
                            <Checkbox
                                isChecked={selectedUser?.external || false}
                                onChange={(e) => setSelectedUser(prev => ({ ...prev, external: e.target.checked }))}
                            >
                                <FormLabel mb={0}>Permitir Acesso Externo</FormLabel>
                            </Checkbox>
                            <Text fontSize="xs" color="gray.500" mt={1}>
                                Permite que o usuário acesse o sistema fora da rede interna (independente do nível)
                            </Text>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" onClick={handleUpdateUser}>Salvar Alterações</Button>
                        <Button onClick={onEditClose} ml={3}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
}

export default Users;